import React, { useState } from 'react'

const Card = ({ category, question, answer, difficulty, id, onCardFlip }) => {
  const [isFlipped, setIsFlipped] = useState(false)
  const [wasFlipped, setWasFlipped] = useState(false)

  const handleCardClick = () => {
    if (!isFlipped) {
      setWasFlipped(true) // Track that the card has been flipped at least once
      onCardFlip(id) // Store the flipped card's ID in local storage
    }
    setIsFlipped(!isFlipped)
  }

  const setCategoryClass = () => {
    switch (category) {
      case 'Science and Nature':
        return 'science'
      case 'Arts and Literature':
        return 'art'
      case 'Entertainment':
        return 'entertainment'
      case 'Geography':
        return 'geography'
      case 'History':
        return 'history'
      case 'Sports and Leisure':
        return 'sports'
      default:
        return 'general'
    }
  }

  const Star = ({ filled }) => (
    <span style={{ color: filled ? '#FFD700' : '#ccc', fontSize: '2rem' }}>★</span>
  )

  const renderStars = (difficulty) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star key={i + 1} filled={i + 1 <= difficulty} />
    ))
  }

  return (
    <div className="card-scene" onClick={handleCardClick}>
      <div className={`card ${isFlipped ? 'card--flipped' : wasFlipped ? 'card--unflip' : ''}`}>
        <div className={`card-face card-backing ${setCategoryClass()}`}>
          <div className={`card-header ${setCategoryClass()}`}>
            <h2>{category}</h2>
          </div>
          <div className="card-content">
            <h3>Question</h3>
            <p>{question}</p>
          </div>
          <div className="stars-container"><span>DIFFICULTY</span><div>{renderStars(difficulty)}</div></div>
        </div>
        <div className={`card-face card-front ${setCategoryClass()}`}>
          <div className={`card-header ${setCategoryClass()}`}>
            <h2>{category}</h2>
          </div>
          <div className="card-content">
            <h3>Answer</h3>
            <p>{answer}</p>
          </div>
          <div className="stars-container"><span>DIFFICULTY</span><div>{renderStars(difficulty)}</div></div>
        </div>
      </div>
    </div>
  )
}

export default Card
